const { createSlice } = require('@reduxjs/toolkit');

const currencySlice = createSlice({
    name: "currency",
    initialState: {
        currencyName: "",
        
    },
    reducers: {
        setCurrency(state, action) {
            const currencyName = action.payload;

            return state = {
                currencyName
            };
            
           
        }
    },
});

export const { setCurrency } = currencySlice.actions;
export default currencySlice.reducer;
